<template>
  <div class="reject-dialog">
    <div class="reject-header">
      <h3 class="reject-title">{{ t('interview.rejectDialogTitle') }}</h3>
      <span class="reject-close" @click="handleClose">
         <Icon name="close" size="xs" />
      </span>
    </div>
    <div class="reject-content">
      <div class="l">{{ t('interview.rejectDialogLabel') }}</div>
      <textarea
        v-model="reason"
        class="reject-textarea"
        :placeholder="t('interview.rejectReasonPlaceholder')"
        rows="4"
        :maxlength="200"
      />
    </div>
    <div class="reject-footer">
      <el-button class="reject-button reject-button-default" @click="handleCancel">
        {{ t('interview.cancelButton') }}
      </el-button>
      <el-button type="primary" class="reject-button " @click="handleConfirm">
        {{ t('interview.rejectDialogButton') }}
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { RejectDialogProps } from './reject-types';

const { t } = useI18n();

const props = defineProps<RejectDialogProps>();

const emit = defineEmits<{
  cancel: [];
  confirm: [reason: string];
  close: [];
}>();

const reason = ref('');

const handleCancel = () => {
  emit('cancel');
};

const handleConfirm = async () => {
  emit('confirm', reason.value);
};

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.reject-dialog {
  min-width: 516px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.reject-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 30px 20px;
}

.reject-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #101729;
}

.reject-close {
  font-size: 18px;
  line-height: 1;
  color: #8c8c8c;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #262626;
  }
}

.reject-content {
  padding: 0px 30px;
  .l {
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    color: #495057;
    margin-bottom: 8px;
  }
}

.reject-textarea {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 22px;
  color: #101729;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.3s;

  &::placeholder {
    color: #bfbfbf;
  }

  &:hover {
    border-color: var(--el-color-primary);
  }

  &:focus {
    // border-color: #4096ff;
    box-shadow: 0 0 0 2px rgba(64, 150, 255, 0.1);
  }
}

.reject-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px 30px;
}

.reject-button {
  min-width: 72px;
  height: 35px;
  padding: 4px 16px;
  font-size: 14px;
  line-height: 22px;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s;
  outline: none;

  &:active {
    transform: translateY(1px);
  }
}

.reject-button-default {
  background: #ffffff;
  height: 35px;
  border-color: #d9d9d9;
  color: #262626;

  &:hover {
    border-color: var(--el-color-primary);
    color: var(--el-color-primary);
  }
}

.reject-button-danger {
  background: #fff;
  border: 1px solid #D84910;
  color: #D84910;

  &:hover {
    // background: #ff7875;
  }
}
</style>
